import { Box, Button, VStack } from '@bpba/ui-components';
import { useLocation, useNavigate } from 'react-router-dom';
import { UrlsBack, UrlsFront } from '../constants/urls';
import useAxios from 'axios-hooks';
import { IFixedTermSimulation } from '../types/IFixedTermSimulation';
import { ICBU } from '../types/ICBU';
import { IFixedTermLegal } from '../types/IFixedTermLegal';
import { FixedTermDetail } from './detail/FixedTermDetail';
import { IFixedTermNewResponse } from '../types/IFixedTermNewResponse';
import { useState } from 'react';
import { DebinResult, IDebin } from '../types/IDebin';
import { DEBIN_STATUS_TO_FIXEDTERM_STATUS, DEBIN_REJECTED_MESSAGE, DEBIN_GENERAL_ERROR, MENU_ITEM_NEW } from '../constants/data';
import { IFixedTermItem } from '../types/IFixedTermItem';
import { ErrorMessageContainer } from '../components/shared/ErrorMessageContainer';
import { PanelDivisor } from '../components/shared/PanelDivisor';
import { SubTitulo } from '../components/shared/SubTitulo';
import { Titulo } from '../components/shared/Titulo';
import { Spinner } from '../components/shared/Spinner';
import { StyledBox } from '../components/shared/StyledBox';
import { AxiosResponse } from 'axios';
import { useErrorMessage } from '../components/shared/useErrorMessage';
import { axiosMessageExtractor } from '../config/axiosMessageExtractor';
import { DebinWarning } from './DebinWarning';
import { DebinPendingWarning } from './DebinPendingWarning';
import { AceptationButton } from './AceptationButton';
import { useScrolltoContent } from '../components/shared/useScrolltoContent';
import { useGetDebin } from '../components/shared/useGetDebin';

type IFixedTermNewRequest = IFixedTermSimulation & ICBU & IFixedTermLegal;

export const FixedTermConfirm = () => {
  const { scrollToTop } = useScrolltoContent();
  const [loading, setLoading] = useState<boolean>(false);
  const { state } = useLocation();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage, showError, clearError] = useErrorMessage(axiosMessageExtractor, DEBIN_GENERAL_ERROR);
  const [getDebin, debinResponse] = useGetDebin();

  const [{ data: response }, post] = useAxios<IFixedTermNewResponse, IFixedTermNewRequest>(
    {
      url: UrlsBack.FixedTermNew,
      method: 'POST',
    },
    { manual: true }
  );

  const redirectToStart = () => {
    navigate(UrlsFront.FixedTerms);
  };

  if (!state) {
    redirectToStart();
  }

  const processResponse2 = ({ data }: AxiosResponse<IDebin, any, {}>) => {
    if (data?.result == null || data.result !== DebinResult.INICIAL) {
      setErrorMessage(DEBIN_REJECTED_MESSAGE);
    }
  };
  const processResponse1 = async ({ data }: AxiosResponse<IFixedTermNewResponse, any, {}>) => {
    if (data?.debin?.id == null) {
      setErrorMessage(DEBIN_REJECTED_MESSAGE);
    } else {
      await getDebin(data.debin.id).then(processResponse2).catch(setErrorMessage);
    }
  };

  const onSubmit = async () => {
    scrollToTop();
    setLoading(true);
    clearError();

    const payload = {
      cbu: state.cbu,
      alias: state.alias,
      amount: state.amount,
      term: state.term,
      IsPep: state.IsPep,
      IsSoi: state.IsSoi,
      IsFatca: state.IsFatca,
    };
    await post({ data: payload }).then(processResponse1).catch(setErrorMessage);

    setLoading(false);
  };

  const countdownData: IFixedTermItem = {
    ...state,
    debinId: debinResponse?.id,
    expiredDateDebin: debinResponse?.expiredDate,
    status: DEBIN_STATUS_TO_FIXEDTERM_STATUS[debinResponse?.result ?? DebinResult.ERROR],
  };

  return (
    <VStack>
      <Titulo>{MENU_ITEM_NEW}</Titulo>
      <PanelDivisor flexDirection={'column'}>
        <SubTitulo>Confirmación de constitución de PF</SubTitulo>
        {loading && <Spinner width={40} my={'48px'} />}
        {!loading && <FixedTermDetail data={state} />}

        <ErrorMessageContainer show={showError} errorMessage={errorMessage} />

        {!loading && !showError && !response && <DebinWarning />}
        {!loading && !showError && response && <DebinPendingWarning />}

        {!loading && !response && !showError && (
          <StyledBox justifyContent={'end'} mt={'24px'}>
            <Button type="button" variant="transparent" onClick={redirectToStart} maxWidth={'200px'}>
              Cancelar
            </Button>
            <Button type="button" variant="primary" onClick={onSubmit} maxWidth={'200px'}>
              Enviar DEBIN
            </Button>
          </StyledBox>
        )}

        {!loading && (response || showError) && (
          <StyledBox justifyContent={'end'} mt={'24px'} flexDirection={['column-reverse', 'row']} alignItems={'end'}>
            <Button type="button" variant="transparent" onClick={redirectToStart} maxWidth={['100%', '200px']} mx={'0px !important'} mt={['0px!important', '24px !important']}>
              Volver
            </Button>
            {!showError && (
              <Box width={['100%', 'fit-content']}>
                <AceptationButton data={countdownData} />
              </Box>
            )}
          </StyledBox>
        )}
      </PanelDivisor>
    </VStack>
  );
};
